/**
 * Menu / hero links saved in admin often use full dev URLs (http://localhost:3000/shop?...).
 * On production that opens localhost for visitors. Strip to same-origin path when the host
 * matches the storefront (or localhost).
 */
export function sanitizeStorefrontUrl(url) {
  if (url == null || typeof url !== 'string') return url || '';
  const s = url.trim();
  if (!s) return '';
  if (!/^https?:\/\//i.test(s)) return s;
  try {
    const u = new URL(s);
    if (u.hostname === 'localhost' || u.hostname === '127.0.0.1') {
      return `${u.pathname}${u.search}${u.hash}` || '/';
    }
    if (typeof window !== 'undefined') {
      const h = window.location.hostname.replace(/^www\./, '');
      const uh = u.hostname.replace(/^www\./, '');
      if (uh === h) {
        return `${u.pathname}${u.search}${u.hash}` || '/';
      }
    }
  } catch (_) {
    return s;
  }
  return s;
}
